define(["uiComponent", "Magento_Customer/js/customer-data"], function(
    Component,
    customerData
) {
    "use strict";

    return Component.extend({
        /**
         * Initialize the cart link
         *
         * @param config {Object}
         * @param elem {HTMLAnchorElement}
         */
        initialize: function(config, elem) {
            var cartData = customerData.get("cart");

            this.elem = elem;

            this.update(cartData());
            cartData.subscribe(function(updatedData) {
                this.update(updatedData);
            }, this);
        },

        /**
         * Update the "identifier attribute" with the latest cart data
         * @param data {Object}
         */
        update: function(data) {
            this.elem.dataset.summaryCount =
                "summary_count" in data ? data.summary_count : "0";
        }
    });
});
